import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex flex-row items-center border-b last:border-b-0"
};
import Card from "@/modules/match/components/Card.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerSuspendedNotification',
  props: {
    notification: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_RouterLink = _resolveComponent("RouterLink");
      const _component_i18n_t = _resolveComponent("i18n-t");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Card, {
        card: __props.notification.payload.card,
        class: "mr-2"
      }, null, 8, ["card"]), _createElementVNode("div", null, [_createVNode(_component_i18n_t, {
        keypath: "player_suspended_for_x_matches"
      }, {
        player: _withCtx(() => [_createVNode(_component_RouterLink, {
          class: "text-green-600 font-bold",
          to: {
            name: 'players.show',
            params: {
              id: __props.notification.payload.playerId
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.notification.payload.playerName), 1)]),
          _: 1
        }, 8, ["to"])]),
        matches: _withCtx(() => [_createTextVNode(_toDisplayString(__props.notification.payload.matches), 1)]),
        competition: _withCtx(() => [_createTextVNode(_toDisplayString(__props.notification.payload.competitionName), 1)]),
        _: 1
      })])]);
    };
  }
});